// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"99b116d9","453":"1b81f9c7"}[chunkId] + ".chunk.js";
};